import { Stack } from "@mui/material";

import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import EntityNotFoundAlert from "@/common/components/AppAlerts/EntityNotFoundAlert";
import AuthorizedTenantElement from "@/common/components/Auth/AuthorizedTenantElement";
import { ViewVariant } from "@/common/ts/layout";
import { VehicleDto } from "@/core/api/generated/v1";

import AssetView from "../../../Asset/View/AssetView";

interface Props {
  vehicle: VehicleDto;
}

export default function AssetTabContent({ vehicle }: Props) {
  return (
    <PageTabContent>
      <AuthorizedTenantElement tenantIdsAny={[vehicle?.tenantId, vehicle?.ownerTenantId]} withAlert>
        <Stack direction='column'>
          {!vehicle.assetMeta?.assetId && <EntityNotFoundAlert />}

          {vehicle.assetMeta?.assetId && (
            <AssetView
              assetId={vehicle.assetMeta?.assetId}
              asset={undefined}
              displayProps={{
                breadcrumbs: false,
                header: true,
                actions: true,
                viewVariant: ViewVariant.Tab,
              }}
              headerProps={{
                withLink: true,
                typographyProps: { variant: "h1" },
              }}
              onDelete={null}
            />
          )}
        </Stack>
      </AuthorizedTenantElement>
    </PageTabContent>
  );
}
